import { useState, useRef } from "react";
import { Button, Form, Input, message, Space, Cascader, Checkbox } from "antd";
import { register, getSignInCode } from "../../http/modules/login";
import { provincial } from "../../components/diqu";
import { useNavigate } from "react-router-dom";

function SignIn(props) {

    const navigate = useNavigate();

    const { tabClickHandler,setIslogin } = props;
    const [phone, setPhone] = useState("");
    const [code, setCode] = useState("");
    const [sendDisable, setSendDisable] = useState(false);
    const [countdown, setCountdown] = useState(60);
    const timeRef = useRef(null);
    const [loading, setLoading] = useState(false);

    //机构所在地
    const [filterObj, setFilterObj] = useState()
    // 是否可以提交
    const [disabled, setDisabled] = useState(true)

    const sendMessage = () => {
        if (!phone) {
            message.error("请输入手机号");
            return;
        } else {
            if (!/^1[3456789]\d{9}$/.test(phone)) {
                message.success("手机格式有误");
                return;
            } else {
                timeRef.current = 60;
                setTimer();
                setSendDisable(true);
                getVerificationCode();
            }
        }
    };

    const setTimer = () => {
        let timer = setInterval(() => {
            if (timeRef.current > 0) {
                timeRef.current--;
                setCountdown(timeRef.current);
            } else {
                setCountdown(60);
                setSendDisable(false);
                clearInterval(timer);
            }
        }, 1000);
    };

    //注册发送短信验证码
    const getVerificationCode = async () => {
        try {
            // setLoading(true);
            const res = await getSignInCode({
                phone: phone
            })
            if (Number(res.code) == 0) {
                message.success('短信已成功发送')
            } else {
                message.success(res.msg)
            }
        } finally {
            setLoading(false);
        }
    };
    // 注册
    const onFinish = async (values) => {
        const res = await register({
            loginName: values.loginName,
            orgName: values.orgName,
            phone: values.phone,
            password: values.password,
            smsCode: values.smsCode,
            province: values.province[0],
            city: values.province[1],
            county: values.province[2],
        });
        if (res.code == 0) {
            localStorage.setItem('token', res.data.accessToken)
            message.success('注册成功!请等待业务人员授权账号。')
            navigate("/organization/homeCentre");
        } else {
            message.error(res?.msg)
        }
    };

    // 机构所在地
    const RegistLoc = (value) => {
        setFilterObj({
            province: value?value[0]:'',
            city: value?value[1]:'',
            county: value?value[2]:'',
        });
    };

    return (
        <div>
            <header>注册</header>
            <Form
                name="basic"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
                labelAlign={"left"}
            >
                <Form.Item
                    name="loginName"
                    rules={[
                        { required: true, message: "字母、数字组合,2-20字符" },
                        {
                            // pattern: new RegExp(/^[\u4e00-\u9fa5a-zA-Z0-9]{2,20}$/),
                            pattern: new RegExp(/^[a-zA-Z0-9]{4,20}$/),
                            message: "字母、数字组合,2-20字符"
                        }
                    ]}
                >
                    <Input placeholder="用户名" />
                </Form.Item>

                <Form.Item
                    name="phone"
                    rules={[
                        { required: true, message: "请输入正确的手机号" },
                        {
                            pattern: new RegExp(/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/),
                            message: "请输入正确的手机号！"
                        }
                    ]}
                >
                    <Input
                        maxLength={11}
                        value={phone}
                        onChange={e => {
                            setPhone(e.target.value);
                        }}
                        placeholder="手机号"
                    />
                </Form.Item>

                { <Form.Item
                    name="smsCode"
                    rules={[
                        { required: true, message: "请输入正确的验证码" },
                        { pattern: new RegExp(/^\d{6}$/), message: "请输入正确的验证码！" }
                    ]}
                >
                    <Space>
                        <Input.Password maxLength={6} value={code} onChange={e => setCode(e.target.value)} placeholder="验证码" />
                        <Button disabled={sendDisable} type="link" onClick={sendMessage}>
                            发送验证码
                            {sendDisable && <span>({countdown})</span>}
                        </Button>
                    </Space>
                </Form.Item> }

                <Form.Item
                    name="orgName"
                    rules={[
                        { required: true, message: "请输入正确机构名称" },
                        {
                            message: "请输入正确机构名称"
                        }
                    ]}
                >
                    <Input placeholder="机构名称" />
                </Form.Item>

                <Form.Item
                    name="province"
                    rules={[
                        { required: true, message: "请输入机构所在地" },
                    ]}
                >
                    <Cascader placeholder="机构所在地" options={provincial} onChange={RegistLoc} />
                </Form.Item>

                <Form.Item
                    name="password"
                    rules={[{ required: true, message: '请输入密码!' },
                    {
                        pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{3,200}$/),
                        message: "至少1个大写字母,1个小写字母和1个数字"
                    }
                    ]}
                >
                    <Input.Password placeholder="密码" />
                </Form.Item>

                <div className="xieYi" style={{ textAlign: "center",fontSize:'0.7rem' }}>
                    <Checkbox onChange={(value) => setDisabled(!value.target.checked)}></Checkbox><p>
                        我已阅读并同意 <span onClick={()=>navigate('/copyright')}>《版权协议》</span> 和 <span onClick={()=>navigate('/privacyPolicy')}>《用户隐私政策》</span> </p>
                </div>

                <Form.Item className="name" style={{ marginTop: '1.9375rem' }}>
                    <Button
                        style={{ width: "100%", height: "100%", borderRadius: "0.6563rem", transition: "unset", fontSize: "1.375rem" }}
                        type="primary"
                        htmlType="submit"
                        disabled={disabled}
                    >
                        注册
                    </Button>
                </Form.Item>
            </Form>
            <footer>已有账号？<span onClick={()=>setIslogin(true)}>立即登录</span></footer>
        </div>
    );
}
export default SignIn;
